import { faImages } from "@fortawesome/pro-regular-svg-icons";

import { AppRole } from "../../../@api";

import { FeatureCard } from "../../components/Pages";
import { createLazyRoleCheckGuard } from "../../components/Routes/Functions/createLazyRoleCheckGuard";
import { lazyRouteWithGuards } from "../../components/Routes/Functions/LazyRouteFunction";
import { Icon } from "../../components/Shared/Icon/Icon";
import { translationKeys } from "../../models/app-translation-keys";
import { RouteConstants } from "../../models/enums";
import { IFeature } from "../iFeature";

const requiredRole = AppRole.ImageGenerationFeature;

export const imageGenerationFeature: IFeature = {
  requiredRole,
  route: {
    path: RouteConstants.ImageGeneration,
    lazy: lazyRouteWithGuards({
      importer: () => import("./ImageGenerationPage"),
      componentName: "ImageGenerationPage",
      guards: [createLazyRoleCheckGuard(requiredRole)],
    }),
  },
  menuItem: {
    id: "imageGeneration",
    label: translationKeys.feature.imageGeneration.link,
    breadCrumbTitle: translationKeys.feature.imageGeneration.breadCrumbTitle,
    url: `/${[RouteConstants.Ai, RouteConstants.ImageGeneration].join("/")}`,
    path: RouteConstants.ImageGeneration,
    showFooter: true,
    icon: () => <Icon icon={faImages} />,
    fontAwesomeIcon: faImages,
  },
  card: (
    <FeatureCard
      featureKey="imageGeneration"
      featureIcon={faImages}
      route={RouteConstants.Ai}
      featureRoute={RouteConstants.ImageGeneration}
    />
  ),
};
